import React, { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

import { getPlayingListing } from '../../../../shared/helpers.js'
import useCurrentTime from '../../../../shared/hooks/useCurrentTime'
import fallbackImage from '../../assets/img/fallback-image.webp'
import LiveTVBadge from '../LiveTVBadge'
import FocusableCard from './FocusableCard'

import type { Channel } from '../../reducers/types/reducerTypes'
import type { CardProps } from './types'

// eslint-disable-next-line import/prefer-default-export
export function LiveCard({
  data,
  index,
  onFocus,
  layout,
  ttsCounterText,
  onArrowPress,
  focusKey,
}: CardProps<Channel>) {
  const navigate = useNavigate()
  const currentTime = useCurrentTime()

  const playingListing = useMemo(
    () => getPlayingListing(data, currentTime),
    [currentTime, data]
  )

  const bgImage = playingListing?.listing_image
    ? `${playingListing.listing_image}?resize=537x310&format=webp`
    : fallbackImage

  const handleOnEnterPress = () => {
    navigate('/livestream', { state: { watchChannelFromHome: data } })
  }

  return (
    <FocusableCard
      index={index}
      onFocus={onFocus}
      layout={layout}
      ttsText={`${ttsCounterText} .... ${data.short_name} .... ${playingListing?.show_title} .... ${playingListing?.episode_title}`}
      onEnterPress={handleOnEnterPress}
      onArrowPress={onArrowPress}
      focusKey={focusKey}
    >
      <div className="card-live">
        <img
          className="card-live__background-image"
          src={bgImage}
          alt={playingListing?.show_title || 'Live TV'}
        />
        <div className="card-live__header">
          <LiveTVBadge />
          {data.feed_image?.white_logo && (
            <img
              className="card-live__logo"
              src={`${data.feed_image?.white_logo}?resize=166x35&format=webp`}
              alt={`${data.short_name} logo`}
            />
          )}
        </div>
        <div className="card-live__footer">
          <h2
            className={`card-live__show-title ${
              playingListing?.episode_title
                ? 'card-live--1-line-text'
                : 'card-live--2-lines-text'
            }`}
          >
            {playingListing?.show_title}
          </h2>
          {playingListing?.episode_title && (
            <p className="card-live__episode-title card-live--1-line-text">
              {playingListing?.episode_title}
            </p>
          )}
        </div>
      </div>
    </FocusableCard>
  )
}
